import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import HomestPricing1 from "../../assets/images/honestpricing_mortgagefees.png";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FisrtTimeBuyerIcon } from "../../assets/icons/firsttime_buyer.svg";
import { ReactComponent as RemortgagingIcon } from "../../assets/icons/remortgages.svg";
import { ReactComponent as HomeMoversIcon } from "../../assets/icons/home_movers.svg";
import { ReactComponent as BuyToLetIcon } from "../../assets/icons/buy_to_let.svg";
import { ReactComponent as ProductTransferIcon } from "../../assets/icons/product_transfer.svg";

const HonestPricing = () => {
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Honest Pricing"
        description="Clear, transparent mortgage advice fees from AK Mortgages, including straightforward information on standard and complex applications."
        path="/about-us/honest-pricing"
      />
      <Hero
        title={`Simple, transparent mortgage advice`}
        subtitle="Honest pricing"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            At AK Mortgages, we believe in being open about our fees from the
            very beginning. Our mortgage advice fees are straightforward,
            competitive, and always explained before you proceed with an
            application. There are no hidden charges or unexpected costs.
          </div>
        </div>
      </Hero>
      <div className="background-container bg-white">
        <div className="content-container column-center gap-xxxl">
          <div className="row gap-xxxxxl row-flex-start">
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                <FisrtTimeBuyerIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  First-time buyer
                </div>
                <div className="content text-primary-1">
                  Supporting first-time buyers with expert mortgage advice,
                  competitive deals, and guidance every step of the way.
                </div>
              </div>
            </div>
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <HomeMoversIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  Home movers
                </div>
                <div className="content text-primary-1">
                  Helping you finance your next property, port existing
                  mortgages, compare deals, and minimise moving costs.
                </div>
              </div>
            </div>
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <RemortgagingIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  reMORTGAGES
                </div>
                <div className="content text-primary-1">
                  Review your current mortgage to secure better rates, reduce
                  payments or release equity confidently today.
                </div>
              </div>
            </div>
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <BuyToLetIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  Buy-to-let
                </div>
                <div className="content text-primary-1">
                  Solutions for landlords purchasing or refinancing rental
                  properties with expert guidance throughout.
                </div>
              </div>
            </div>
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <ProductTransferIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  PRODUCT TRANSFER
                </div>
                <div className="content text-primary-1">
                  Switch to a new deal with your current lender quickly while
                  reviewing suitability and savings.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-white">
        <div className="content-container column-center gap-xl">
          <div className="subtitle-semibold  text-primary-2 uppercase text-center">
            PRICING
          </div>
          <div className="column gap-xs">
            <h2 className="text-primary-1 uppercase text-left align-left">
              MORTGAGE FEES
            </h2>
            <div className="content text-primary-1">
              We believe in being clear and transparent about our fees from the
              outset.
            </div>
          </div>
          <div className="column gap-xs">
            <div className="content-semibold text-primary-1">
              Simple Applications
            </div>
            <div className="content text-primary-1">
              Most mortgage applications fall under our standard fee. This
              applies to straightforward cases with standard lending criteria.
              We'll always confirm the fee before we begin your application.
            </div>
          </div>
          <div className="column gap-xs">
            <div className="content-semibold text-primary-1">
              Complex Applications
            </div>
            <div className="content text-primary-1">
              Some mortgage applications require additional research, lender
              liaison and specialist knowledge, so a higher fee may apply. This
              can include cases involving adverse credit, government schemes,
              Joint Borrower Sole Proprietor (JBSP) mortgages, Special Purpose
              Vehicle (SPV) applications, and certain buy-to-let mortgages. If
              your application is considered complex, we'll discuss this with
              you and confirm the fee before you proceed.
            </div>
          </div>
          <img src={HomestPricing1} alt="Transparent mortgage advice fees" className="hero-image" />
          <div className="column gap-xs">
            <h2 className="text-primary-1 uppercase text-left align-left">
              ADDITIONAL INFORMATION
            </h2>
            <ul className="content text-primary-1 column gap-m">
              <li>
                £150 cashback after completion for all purchase or capital raise
                remortgage applications.
              </li>
              <li>
                Complex applications (e.g. adverse credit, government schemes,
                JBSP, SPV and certain Buy-to-Let cases) may incur a higher fee.
                We'll always confirm this before proceeding.
              </li>
              <li>
                We receive commission from the lender once your mortgage
                completes.
              </li>
              <li>
                No fee is charged for protection or general insurance advice as
                we receive commission from the insurer.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-3">
        <div className="content-container column-center gap-xl">
          <div className="subtitle-semibold text-primary-1 text-center width-100">
            New client cashback
          </div>
          <div className="body2 text-primary-1 text-center width-100">
            As a welcome to AK Mortgages, eligible new clients can receive £150
            cashback following the successful completion of certain mortgage
            applications.
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              need more information
            </div>
            <div className="column gap-s">
              <div className="content text-white">
                We'll provide a full breakdown of any fees applicable to your
                circumstances before you commit to anything, so you'll always
                know exactly what to expect. Book a free consultation today to
                discuss your mortgage and protection needs.
              </div>
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default HonestPricing;
